import React from 'react';

import { Grid, Typography } from '@mui/material';
import { NumberInput, SelectInput } from 'react-admin';
import currencies from '../../../constants/currencies';
import CommentInput from '../../comment/CommentInput';

const ForecastedTurnover = () => (
  <Grid container spacing={10}>
    <Grid size={12}>
      <Typography
        color="#646464"
        variant="h6"
      >
        Estimated yearly turnover for the current year
      </Typography>
    </Grid>
    <Grid
      size={{
        xs: 12,
        md: 7,
      }}
    >
      <Grid container spacing={10}>
        <Grid
          size={{
            xs: 12,
            md: 6,
          }}
        >
          <NumberInput fullWidth source="value.value" label="New value" />
        </Grid>
        <Grid
          size={{
            xs: 12,
            md: 6,
          }}
        >
          <SelectInput
            choices={currencies.map((curr) => ({
              name: curr,
              id: curr,
            }))}
            fullWidth
            source="value.currency"
            label="New currency"
          />
        </Grid>
        <Grid size={12}>
          <CommentInput
            source="comment"
            helperText={false}
            placeholder="Please explain your decision."
          />
        </Grid>
      </Grid>
    </Grid>
  </Grid>
);

export default ForecastedTurnover;
